import React, { useState, useEffect } from 'react';
import styles from './Facilities.module.css';
import { useData } from '../contexts/DataContext';

const Facilities = () => {
  const { hotelData, loading } = useData();
  const [isHoursExpanded, setIsHoursExpanded] = useState(false);
  const [barHours, setBarHours] = useState([]);
  const [restaurantHours, setRestaurantHours] = useState([]);

  // Process data when hotelData changes
  useEffect(() => {
    if (hotelData) {
      setBarHours(hotelData.openingHours?.bar || []);
      setRestaurantHours(hotelData.openingHours?.restaurant || []);
    } else {
      // Fallback to default data when no hotelData available
      setBarHours([
        { day: 'Monday', hours: '5:00 PM - 9:30 PM' },
        { day: 'Tuesday', hours: '5:00 PM - 9:30 PM' },
        { day: 'Wednesday', hours: '5:00 PM - 11:00 PM' },
        { day: 'Thursday', hours: '4:00 PM - 11:00 PM' },
        { day: 'Friday', hours: '4:00 PM - 11:00 PM' },
        { day: 'Saturday', hours: '3:00 PM - 11:00 PM' },
        { day: 'Sunday', hours: '3:00 PM - 9:30 PM' }
      ]);
      setRestaurantHours([
        { day: 'Monday', hours: 'Closed' },
        { day: 'Tuesday', hours: 'Closed' },
        { day: 'Wednesday', hours: '5:30 PM - 8:30 PM' },
        { day: 'Thursday', hours: '5:30 PM - 8:30 PM' },
        { day: 'Friday', hours: '5:30 PM - 8:30 PM' },
        { day: 'Saturday', hours: '5:30 PM - 8:30 PM' },
        { day: 'Sunday', hours: '12:00 PM - 8:30 PM' }
      ]);
    }
  }, [hotelData]);

  const facilities = [
    { icon: 'pets', text: 'Dog-friendly' },
    { icon: 'local_parking', text: 'Free Parking' },
    { icon: 'restaurant', text: 'Restaurant' },
    { icon: 'shower', text: 'En-suite Rooms' },
    { icon: 'wifi', text: 'Free WiFi' },
    { icon: 'castle', text: 'Castle View' }
  ];

  const toggleHours = () => {
    setIsHoursExpanded(!isHoursExpanded);
  };

  return (
    <div className={styles.facilities}>
      <div className={styles['facilities-container']}>
        <div className={styles['facilities-grid']}>
          {facilities.map((facility, index) => (
            <div key={index} className={styles['facility-item']}>
              <span className={`material-icons ${styles['facility-icon-material']}`}>{facility.icon}</span>
              <span className={styles['facility-text']}>{facility.text}</span>
            </div>
          ))}
        </div>
        
        <div className={styles['opening-hours']}>
          <button className={styles['hours-toggle']} onClick={toggleHours}>
            Opening Hours <span className={styles['hours-arrow']}>{isHoursExpanded ? '▲' : '▼'}</span>
          </button>
          <div 
            className={`${styles['hours-content']} ${isHoursExpanded ? styles.expanded : ''}`}
            data-testid="hours-content"
          >
            {loading ? (
              <div className={styles['loading-message']}>Loading hours...</div>
            ) : (
              <>
                <div className={styles['hours-section']}>
                  <h4>Bar Hours</h4>
                  {barHours.map((item, index) => (
                    <div key={index} className={styles['hours-day']}>
                      <span className={styles['day-name']}>{item.day}</span>
                      <span className={styles['day-hours']}>{item.hours}</span>
                    </div>
                  ))}
                </div>
                
                <div className={styles['hours-section']}>
                  <h4>Restaurant Hours</h4>
                  {restaurantHours.map((item, index) => (
                    <div key={index} className={styles['hours-day']}>
                      <span className={styles['day-name']}>{item.day}</span>
                      <span className={styles['day-hours']}>{item.hours}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facilities;